import {
  OrderLabourInfo,
  OrderResponseDetail,
} from '../../../../../../src/api/cart/interfaces'
import { LaborItem } from '../../../../../../src/store/models/LaborModel'

const mapOrderLabourInfoToLaborItem = (labor: OrderLabourInfo): LaborItem => ({
  laborId: labor.laborId,
  laborDescription: labor.description,
  details: labor.details,
  hours: labor.hours,
  laborRate: String(labor.rate),
  rate: labor.rate,
  warrantyHrs: labor.warrantyHours,
  skillLevel: labor.skillLevel,
  miscellaneousText: labor.notes,
  bold: '',
  groupId: '',
  unansweredSpecific: '',
})

type LocationWithLabors = {
  labors?: OrderLabourInfo[]
}

const getLaborFromLocations = (
  orderDetails: OrderResponseDetail
): LaborItem[] => {
  const laborItems: LaborItem[] = []

  orderDetails.locations?.forEach((location) => {
    const labors = (location as LocationWithLabors).labors
    labors?.forEach((labor) => {
      laborItems.push(mapOrderLabourInfoToLaborItem(labor))
    })
  })

  return laborItems
}

const dedupeLaborItems = (items: LaborItem[]): LaborItem[] => {
  const seen = new Set<number>()
  return items.filter((item) => {
    if (seen.has(item.laborId)) {
      return false
    }
    seen.add(item.laborId)
    return true
  })
}

export const getReceiptLaborItems = (
  orderDetails: OrderResponseDetail
): LaborItem[] => {
  const fromLaborData = orderDetails.laborData ?? []
  if (fromLaborData.length > 0) {
    return fromLaborData
  }

  return dedupeLaborItems(getLaborFromLocations(orderDetails))
}
